<template>
  <div class="storage">
    <el-radio-group v-model="pageVisible" size="small" @change="radioChange">
      <el-radio-button label="1">在库查询</el-radio-button>
      <el-radio-button label="2">在库批次</el-radio-button>
      <el-radio-button label="3">出入库</el-radio-button>
      <el-radio-button label="4">退件销毁</el-radio-button>
      <el-radio-button label="5">出入库记录</el-radio-button>
      <el-radio-button label="6">退件销毁记录</el-radio-button>
    </el-radio-group>
    <el-form
      class="custom-formScreen"
      :model="formScreen"
      ref="formScreen"
      label-width="4.8vw"
      inline
    >
      <el-form-item label="分公司" prop="branchCompanyId">
        <el-select v-model="formScreen.branchCompanyId" filterable placeholder="请选择" @change="selectChange">
          <el-option
            v-for="item in listBranch"
            :key="item.id"
            :label="item.companyFullName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子公司" prop="companyId">
        <el-select v-model="formScreen.companyId" filterable placeholder="请选择">
          <el-option
            v-for="item in listSon"
            :key="item.id"
            :label="item.companyFullName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startTimeString">
        <el-date-picker
          v-model="formScreen.startTimeString"
          align="right"
          type="date"
          placeholder="选择开始日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTimeString">
        <el-date-picker
          v-model="formScreen.endTimeString"
          align="right"
          type="date"
          placeholder="选择结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>

      <template v-if="pageVisible <=2">
        <el-form-item label="仓库" prop="warehouseName">
          <el-select v-model="formScreen.warehouseName" value-key="id" @change="getShelvesList">
            <el-option
              v-for="item in listWarehouse"
              :key="item.id"
              :label="item.warehouseName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货架" prop="shelfType">
          <el-select v-model="formScreen.shelfType" value-key="id">
            <el-option
              v-for="item in listShelves"
              :key="item.id"
              :label="item.shelfNumber"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="pageVisible >= 3">
        <el-form-item label="类型" prop="operateType">
          <el-select v-model="formScreen.operateType">
            <el-option
              v-for="item in GoodsType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label=" " prop="searchString" style="width: 40%">
        <el-input
          v-model.trim="formScreen.searchString"
          placeholder="全字段搜索"
          style="width: calc(100% - 140px);"
        ></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="search">搜索</el-button>
        <el-button type="primary" @click="resetFprm('formScreen')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-button v-if="pageVisible === '4'" type="primary" style="margin-bottom:15px;" @click="downExcel">出入库记录导出</el-button>
    <el-button v-if="pageVisible === '3'" type="primary" style="margin-bottom:15px;" @click="downExcel1">出入库导出</el-button>
    <!--1. 在库查询 表格 -->
    <el-table :data="listTable" border style="width: 100%" v-show="pageVisible === '1'">
      <el-table-column prop="inventoryNumber" width="200" label="库存编号" align="center"></el-table-column>
      <el-table-column label="图片" width="120" align="center">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right" style="float: left">
            <img :src="scope.row.imagesList[0]" class="prduct_img" alt />
            <div class="scope_img" slot="reference">
              <img :src="scope.row.imagesList[0]" alt />
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="productFullName" width="200" label="全称" align="center"></el-table-column>
      <el-table-column prop="purchaseQuantity" width="100" label="采购数量" align="center"></el-table-column>
      <el-table-column prop="predictCount" width="100" label="申请库存" align="center"></el-table-column>
      <el-table-column prop="actualCount" width="100" label="实际库存" align="center"></el-table-column>
      <!-- <el-table-column prop="averageWeight" width="120" label="平均计费重" align="center"></el-table-column> -->
      <!-- <el-table-column prop="productType" width="120" label="货物类型" align="center"></el-table-column> -->
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}</span>
            <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
            <span>{{ scope.row.subCompanyName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" width="200" label="入库时间" align="center"></el-table-column>
      <el-table-column prop="updateTime" width="200" label="更新时间" align="center"></el-table-column>
      <el-table-column label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <i class="el-icon-edit-outline fontSize-30" @click="InLibrary(scope.row)"></i>
          <!-- <i class="el-icon-edit-outline fontSize-30" @click="Application_for_warehousing(scope.row)"></i> -->
          <!-- <i class="el-icon-edit-outline fontSize-30" @click="Application_for_export(scope.row)"></i> -->
        </template>
      </el-table-column>
    </el-table>
    <!--2. 在库批次 表格  BatchTable-->
    <el-table :data="BatchTable" border style="width: 100%" v-show="pageVisible === '2'">
      <el-table-column prop="inventoryNumber" width="200" label="库存编号" align="center">
          <template slot-scope="scope">
                <p>库存号：{{scope.row.inventoryNumber}}</p>
              <p>批次号：{{scope.row.inventoryBatchNo}}</p>
          </template>
      </el-table-column>
      <el-table-column label="图片" width="120" align="center">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right" style="float: left">
            <img :src="scope.row.imagesList[0]" class="prduct_img" alt />
            <div class="scope_img" slot="reference">
              <img :src="scope.row.imagesList[0]" alt />
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="productFullName" width="200" label="全称" align="center"></el-table-column>
      <el-table-column prop="warehouseName" width="150" label="仓库" align="center"></el-table-column>
      <el-table-column prop="shelfNumber" width="100" label="货架" align="center"></el-table-column>
      <el-table-column prop="actualCount" width="100" label="库存" align="center"></el-table-column>
      <el-table-column prop="averageWeight" width="120" label="平均计费重" align="center"></el-table-column>
      <el-table-column prop="inventorySku" width="120" label="规格尺寸" align="center"></el-table-column>
      <el-table-column prop="productType" width="120" label="货物类型" align="center"></el-table-column>
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}</span>
            <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
            <span>{{ scope.row.subCompanyName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" width="100" label="入库时间" align="center"></el-table-column>
      <el-table-column prop="updateTime" width="100" label="更新时间" align="center"></el-table-column>
      <el-table-column label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <i class="el-icon-edit-outline fontSize-30" @click="Application_for_save(scope.row)"></i>
          <!-- <i class="el-icon-edit-outline fontSize-30" @click="Application_for_warehousing(scope.row)"></i> -->
          <!-- <i class="el-icon-edit-outline fontSize-30" @click="Application_for_export(scope.row)"></i> -->
        </template>
      </el-table-column>
    </el-table>
    <!--3. 出入库 表格 -->
    <el-table :data="listTable2"  border style="width: 100%" v-show="pageVisible === '3'">
      <el-table-column width="200" label="库存编号/订单号" align="center">
          <template slot-scope="scope">
            <p>{{scope.row.inventoryNumber}}</p>
            <p>{{scope.row.amazonOrderId}}</p>
            <p>{{scope.row.inventoryBatchNo}}</p>
          </template>
      </el-table-column>
      <el-table-column label="图片" width="120" align="center">
        <template slot-scope="scope">
          <el-popover
            trigger="hover"
            placement="right"
            style="float: left"
            v-if="scope.row.imagesList"
          >
            <img :src="scope.row.imagesList[0]" class="prduct_img" alt />
            <div class="scope_img" slot="reference">
              <img :src="scope.row.imagesList[0]" alt />
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="productFullName" min-width="200" label="全称" align="center"></el-table-column>
      <el-table-column label="数量" min-width="80" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.operateType === 1">{{scope.row.actualCount}}</div>
          <div v-if="scope.row.operateType === 2">{{scope.row.useCount}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="averageWeight" width="100" label="平均计费重" align="center"></el-table-column>
      <el-table-column prop="productType" width="100" label="货物类型" align="center"></el-table-column>
      <el-table-column width="100" label="类型" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.operateType === 1">入库</div>
          <div v-else-if="scope.row.operateType === 2">出库</div>
          <div v-else-if="scope.row.operateType === 3">销毁</div>
        </template>
      </el-table-column>
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}</span>
            <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
            <span>{{ scope.row.subCompanyName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" width="200" label="创建时间" align="center"></el-table-column>
      <el-table-column prop="updateTime" width="200" label="更新时间" align="center"></el-table-column>
      <el-table-column label="操作" fixed="right" width="100" align="center">
        <template slot-scope="scope">
          <!-- <i class="el-icon-edit-outline fontSize-30" @click="InLibrary(scope.row)"></i> -->
          <el-button type="primary" v-if="scope.row.operateType === 1" @click="Application_for_export(scope.row)">入库</el-button>
          <el-button type="primary" v-if="scope.row.operateType === 2" @click="Application_for_warehousing(scope.row)">出库</el-button>
          <el-button type="danger" v-if="scope.row.operateType === 3" @click="Application_for_destruction(scope.row)">销毁</el-button>
 
        </template>
      </el-table-column>
    </el-table>
   <!-- 4.退件销毁表格 -->
    <el-table :data="FiveTableData" border style="width: 100%" v-show="pageVisible === '4'">
      <el-table-column  width="200" label="库存编号" align="center">
           <template slot-scope="scope">
               <p>库存号：{{scope.row.inventoryNumber}}</p>
               <p>批次号：{{scope.row.inventoryBatchNo}}</p>
        </template>
      </el-table-column>
      <el-table-column label="图片" width="120" align="center">
        <template slot-scope="scope">
          <el-popover v-if="scope.row.imagesList !=null" trigger="hover" placement="right" style="float: left">
            <img :src="scope.row.imagesList[0]" class="prduct_img" alt />
            <div class="scope_img" slot="reference">
              <img :src="scope.row.imagesList[0]" alt />
            </div>
          </el-popover>
          <div v-else>
              暂无图片
          </div>
        </template>
      </el-table-column>
        <el-table-column prop="productFullName" width="200" label="全称" align="center"></el-table-column>
        <el-table-column prop="productSimpleName" width="150" label="简称" align="center"></el-table-column>
      <el-table-column prop="productDescription" width="150" label="描述" align="center"></el-table-column>
      <el-table-column prop="useCount"  width="110" label="退件/销毁数量" align="center"></el-table-column>
      <el-table-column prop="operateType" width="80" label="货物类型" align="center">
               	<template slot-scope="scope">
							<!-- {{ scope.row.operateType  }} -->
							{{ scope.row.operateType == 2? "销毁":"退件" }}
						</template>
      </el-table-column>
      <el-table-column width="120" label="角色" align="center">
          	<template slot-scope="scope">
							{{ scope.row.userName }}-{{scope.row.roleName}}
						</template>
      </el-table-column>
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}-{{scope.row.chineseShortName}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" width="100" label="创建时间" align="center"></el-table-column>
      <el-table-column prop="remark" width="170" label="备注" align="center"></el-table-column>
      <!-- <el-table-column prop="updateTime" width="170" label="更新时间" align="center"></el-table-column> -->
      <el-table-column label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button @click="Ruin(scope.row)" type="danger" v-if="scope.row.operateType === 2">销毁</el-button>
          <el-button @click="Sales(scope.row)" type="primary"  v-if="scope.row.operateType === 3">退件</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--5. 出入库记录表格 -->
    <el-table :data="listTable3"  border style="width: 100%" v-show="pageVisible === '5'">
      <el-table-column width="200" label="库存编号/订单号" align="center">
          <template slot-scope="scope">
            <p>{{scope.row.inventoryNumber}}</p>
            <p>{{scope.row.amazonOrderId}}</p>
          </template>
      </el-table-column>
      <el-table-column label="图片" width="120" align="center">
        <template slot-scope="scope">
          <el-popover
            trigger="hover"
            placement="right"
            style="float: left"
            v-if="scope.row.imagesList"
          >
            <img :src="scope.row.imagesList[0]" class="prduct_img" alt />
            <div class="scope_img" slot="reference">
              <img :src="scope.row.imagesList[0]" alt />
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="数量" min-width="80" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.operateType === 1">{{scope.row.actualCount}}</div>
          <div v-if="scope.row.operateType === 2">{{scope.row.useCount}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="productFullName" min-width="200" label="全称" align="center"></el-table-column>
      <el-table-column prop="averageWeight" width="100" label="平均计费重" align="center"></el-table-column>
      <el-table-column prop="productType" width="100" label="货物类型" align="center"></el-table-column>
      <el-table-column width="100" label="类型" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.operateType === 1">入库</div>
          <div v-else-if="scope.row.operateType === 2">出库</div>
          <div v-else-if="scope.row.operateType === 3">销毁</div>
        </template>
      </el-table-column>
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}</span>
            <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
            <span>{{ scope.row.subCompanyName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="confirmTime" width="200" label="出入库时间" align="center"></el-table-column>
      <el-table-column prop="createTime" width="200" label="创建时间" align="center"></el-table-column>
      <el-table-column prop="updateTime" width="200" label="更新时间" align="center"></el-table-column>
      <el-table-column width="100" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="BarCode(scope.row)">打印</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 退件销毁记录  MeltRetreat-->
    <el-table :data="MeltRetreatData"  border style="width: 100%" v-show="pageVisible === '6'">
     <el-table-column  width="240" label="库存编号" align="center">
           <template slot-scope="scope">
               <p>库存号：{{scope.row.inventoryNumber}}</p>
               <p>批次号：{{scope.row.inventoryBatchNo}}</p>
        </template>
      </el-table-column>
      <el-table-column label="图片" width="120" align="center">
        <template slot-scope="scope">
          <el-popover v-if="scope.row.imagesList !=null" trigger="hover" placement="right" style="float: left">
            <img :src="scope.row.imagesList[0]" class="prduct_img" alt />
            <div class="scope_img" slot="reference">
              <img :src="scope.row.imagesList[0]" alt />
            </div>
          </el-popover>
          <div v-else>
              暂无图片
          </div>
        </template>
      </el-table-column>
        <el-table-column prop="productFullName" width="200" label="全称" align="center"></el-table-column>
        <el-table-column prop="productSimpleName" width="150" label="简称" align="center"></el-table-column>
      <el-table-column prop="productDescription" width="150" label="描述" align="center"></el-table-column>
      <el-table-column prop="useCount"  width="150" label="退件/销毁数量" align="center"></el-table-column>
      <el-table-column prop="operateType" width="120" label="货物类型" align="center">
               	<template slot-scope="scope">
							<!-- {{ scope.row.operateType  }} -->
							{{ scope.row.operateType == 2? "销毁":"退件" }}
						</template>
      </el-table-column>
      <el-table-column width="120" label="角色" align="center">
          	<template slot-scope="scope">
							{{ scope.row.userName }}-{{scope.row.roleName}}
						</template>
      </el-table-column>
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}-{{scope.row.chineseShortName}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" width="170" label="入库时间" align="center"></el-table-column>
      <!-- <el-table-column width="100" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="BarCode(scope.row)">打印</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <el-row type="flex" justify="center" align="middle" class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>

    <!-- 退件 -->
    <el-dialog title="退件处理" width="50%" :visible.sync="TuilVisible" append-to-body>
            <div class="out-handle-box">
                <p >收件人：{{SalesObj.recipientName}}</p>
                <p style="margin-top:20px">收货地址：{{SalesObj.receivingAddress}}</p>
                <p style="margin-top:20px">收件人电话：{{SalesObj.recipientTelephone}}</p>
                <p style="margin-top:20px">库存编号：{{SalesObj.inventoryNumber}}</p>
                <p style="margin-top:20px">退件数量：{{SalesObj.useCount}}</p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="TuilVisible = false">取 消</el-button>
                <el-button @click="CanceSales()" type="primary">确 定</el-button>
            </div>
        </el-dialog>
    <!-- 销毁操作 -->
      <el-dialog title="销毁处理" width="50%" :visible.sync="CancelVisible" append-to-body>
            <div class="out-handle-box">
                <p>库存编号：{{this.RuinObj.inventoryNumber}}</p>
                <p style="margin-top:20px">销毁数量：{{this.RuinObj.useCount}}</p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="CancelVisible = false">取 消</el-button>
                <el-button type="primary" @click="CancelRuin()">确 定</el-button>
            </div>
        </el-dialog>

    <InLibrary ref="InLibrary"   @confirm="ApplicationforsaveConfirm"/>
    <!-- 出库 -->
    <Applicationforwarehousing ref="Applicationforwarehousing" @confirm="ApplicationForWarehouseConfirm"/>
    <!-- 入库 -->
    <Applicationforexport ref="Applicationforexport" @confirm="ApplicationforexportConfirm" />
    <Applicationfordestruction ref="Applicationfordestruction" @confirm="ApplicationfordestructionConfirm" />
  </div>
</template>

<script>
import InLibrary from "./storageDepartment/InLibrary";
// 出库
import Applicationforwarehousing from "./storageDepartment/Application_for_warehousing";
// 入库
import Applicationforexport from "./storageDepartment/Application_for_export";
// 销毁
import Applicationfordestruction from "./storageDepartment/Application_for_destruction";
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
  name: "Storage",
  components: {
    InLibrary,
    Applicationforwarehousing,
    Applicationforexport,
    Applicationfordestruction
  },
  data() {
    return {
        MeltRetreatData:[],
        TuilVisible:false,
        SalesObj:{},
        RuinObj:{},
        CancelVisible:false,
      pageVisible: "1",
      page: 1,
      size: 20,
      total: 0,
      formScreen: {
        startTimeString: "",
        endTimeString: "",
        searchString: "",
        operateType: '',
        branchCompanyId: '',
        companyId: '',
        warehouseName: '',
        shelfType: ''
      },
      listBranch: [],
      listSon: [],
      listTable: [],
      BatchTable:[],
      listTable2: [],
      listTable3: [],
      FiveTableData:[],
      listWarehouse: [], //仓库
      listShelves: [], //货架
      Operatorlist: [],
      GoodsType: [
        { value: '1', label: '入库' },
        { value: '2', label: '出库' },
        { value: '3', label: '销毁' },
      ]
    };
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    this.getBranchCompanyList();
    this.radioChange();
    this.getWarehouseList()
  },
  methods: {
    //   退件
      Sales(row){
          const API = Baseurl+ "inventoryController/getAddressByBatchNoId";
          ajaxPost(API,{id:row.purchaseId}).then(res=>{
              if(res.data.code== 200){
                  if(res.data.data==null){
                    //   console.log(JSON.parse(JSON.stringify(row)))
                       this.SalesObj = {
                           recipientName:"",
                           receivingAddress:"",
                           recipientTelephone:"",
                           inventoryNumber:row.inventoryNumber,
                           useCount:row.useCount
                       }
                  }else{
                        this.SalesObj = res.data.data;
                          this.SalesObj.inventoryNumber = row.inventoryNumber;
                            this.SalesObj.useCount = row.useCount;
                            this.SalesObj.goodsId = row.id;
                        }
                   
                  
              }
          });
          this.TuilVisible = true;
      },
    //   销毁
      Ruin(row){
          this.RuinObj = row;
          this.CancelVisible = true;
      },
    //   退件
    CanceSales(){
          this.$confirm('确定要退件吗？', '提示').then(() => {
             const API = Baseurl+ "inventoryController/confirmReturnInventory";
            ajaxPost(API,{id:this.SalesObj.goodsId,roleId:Number(this.UserInfo.rid)}).then(res=>{
                if(res.data.code ==200){
                    this.$message.success("退件成功");
                    this.TuilVisible = false;
                    this.FiveTable();
                }else{
                    this.$message.error(res.data.message);
                    this.TuilVisible = true;
                }
            })
      })
    },
    //   销毁
      CancelRuin(){
        this.$confirm('确定要销毁吗？', '提示').then(() => {
             const API = Baseurl+ "inventoryController/confirmDestroyInventory";
            ajaxPost(API,{id:this.RuinObj.id,roleId:Number(this.UserInfo.rid)}).then(res=>{
                if(res){
                      this.$message.success("销毁成功");
                    this.CancelVisible = false;    
                    this.FiveTable();
                }else{
                     this.$message.error(res.data.message);
                     this.CancelVisible = true; 
                }
            })
        })
           
      },
    InLibrary(row) {
      this.$refs.InLibrary.init(row,this.pageVisible);
    },
    Application_for_save(row) {
      this.$refs.InLibrary.init(row);
    },
    Application_for_warehousing(row) {
      this.$refs.Applicationforwarehousing.init(row);
    },
    Application_for_export(row) {
      this.$refs.Applicationforexport.init(row);
    },
    Application_for_destruction(row) {
      this.$refs.Applicationfordestruction.init(row);
    },
    search() {
      this.page = 1
      this.changeSearch()
    },
    changeSearch() {
      if(this.pageVisible === "1" ){
        this.getListTable()
      }else if(this.pageVisible === "2"){
        this.getTableData()
      }else if(this.pageVisible === "3"){
        this.getListTable2()
      }else if(this.pageVisible === "4"){
        this.FiveTable();
      }else if(this.pageVisible === "5"){
          this.getListTable3();
      }else if(this.pageVisible === "6"){
          this.MeltRetreat();
      }
    },
    resetFprm(formName) {
      this.page = 1
      this.$refs[formName].resetFields();
      this.listSon = []
      this.changeSearch()
    },
    // Operatorform(queryString, cb) {
    //   this.common.setOption(queryString, cb, this.Operatorlist);
    // },
    handleSizeChange(val) {
      this.size = val
    //   console.log(`每页 ${val} 条`);
      this.changeSearch()
    },
    handleCurrentChange(val) {
      this.page = val
    //   console.log(`当前页: ${val}`);
      this.changeSearch()
    },
    radioChange() {
      this.page = 1;
      this.size = 20;
     if(this.pageVisible === "1" ){
        this.getListTable()
      }else if(this.pageVisible === "2"){
        this.getTableData()
      }else if(this.pageVisible === "3"){
        this.getListTable2()
      }else if(this.pageVisible === "4"){
        this.FiveTable();
      }else if(this.pageVisible === "5"){
          this.getListTable3()
      }else if(this.pageVisible === "6"){
          this.MeltRetreat();
      }
      
    },
    selectChange(id) {
      this.getSonCompanyList(id);
    },
    getWarehouseList() {
      if (this.listWarehouse.length) return;
      const API = Baseurl + "inventoryController/getWarehouseList";
      ajaxPost(API).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listWarehouse = data;
        //   this.formScreen.warehouseName = data[0];
          this.getShelvesList();
        }
      });
    },
    getShelvesList() {
      const API = Baseurl + "inventoryController/getShelfsByWarehouseId";
      const paramsData = {
        warehouseId: this.formScreen.warehouseName.id
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listShelves = data;
        }
      });
    },
    getBranchCompanyList() {
      const API = Baseurl + "logisticsController/getAllBranchCompany";
      ajaxPost(API).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listBranch = data;
        }
      });
    },
    getSonCompanyList(id) {
      const API = Baseurl + "logisticsController/getAllSubCompanyById";
      const paramsData = { id };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listSon = data;
        }
      });
    },
    // 1111111111
    getListTable() {
      const API = Baseurl + "inventoryController/selectOnInventoryList";
      const { startTimeString,
        endTimeString,
        branchCompanyId,
        companyId,
        searchString,
        operateType } = this.formScreen
      const paramsData = {
        page: this.page,
        size: this.size,
        warehouseName: this.formScreen.warehouseName.warehouseName,
        shelfNumber: this.formScreen.shelfType.shelfNumber,
        startTimeString,
        endTimeString,
        branchCompanyId,
        companyId,
        searchString,
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          data.list.forEach(item => (item.averageWeight = Number(item.averageWeight).toFixed(2)));
          this.listTable = data.list;
          this.total = data.total;
        }
      });
     
    },
    // 22222222
    getTableData(){
         const { startTimeString,
        endTimeString,
        branchCompanyId,
        companyId,
        searchString,
        operateType } = this.formScreen
      const paramsData = {
        page: this.page,
        size: this.size,
        warehouseName: this.formScreen.warehouseName.warehouseName,
        shelfNumber: this.formScreen.shelfType.shelfNumber,
        startTimeString,
        endTimeString,
        branchCompanyId,
        companyId,
        searchString
      };
    //   console.log(JSON.parse(JSON.stringify(paramsData)))
       ajaxPost(Baseurl+"inventoryController/selectOnInventoryBatchList",paramsData).then(res=>{
            const { code, data } = res.data;
        if (code === 200) {
            //  console.log(JSON.parse(JSON.stringify(data)))
          data.list.forEach(item => (item.averageWeight = Number(item.averageWeight).toFixed(2)));
          this.BatchTable = data.list;
        //   console.log(this.BatchTable)
          this.total = data.total;
        }
      })
    },
    // 3333333333
    getListTable2() {
      const API = Baseurl + "inventoryController/selectInventoryOperateList";
      const { startTimeString,
        endTimeString,
        branchCompanyId,
        companyId,
        searchString,
        operateType } = this.formScreen
      const paramsData = {
        page: this.page,
        size: this.size,
        startTimeString,
        endTimeString,
        branchCompanyId,
        companyId,
        searchString,
        operateType
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          data.list.forEach(item => (item.averageWeight = Number(item.averageWeight).toFixed(2)));
          this.listTable2 = data.list;
          this.total = data.total;
        }
      });
    },
     // 44444444444
    FiveTable(){
        const API = Baseurl+"inventoryController/getInventoryBatchOperateList";
             const { startTimeString,
                    endTimeString,
                    branchCompanyId,
                    companyId,
                    searchString
                                } = this.formScreen
        const paramsData = {
             page: this.page,
             size: this.size,
             startTimeString,
             endTimeString,
             branchCompanyId,
             companyId,
             searchString,
            };
        ajaxPost(API,paramsData).then(res=>{
            if(res.data.code == 200){
                this.FiveTableData = res.data.data.list;
                // console.log(res.data.data.total)
                  this.total = res.data.data.total;
            }else{
                this.$message.error(res.data.message)
            }
            // console.log(res)
        })
    },
    // 5555555555
    getListTable3() {
      const API = Baseurl + "inventoryController/selectInventoryOperateHistory";
      const { startTimeString,
        endTimeString,
        branchCompanyId,
        companyId,
        searchString,
        operateType } = this.formScreen
      const paramsData = {
        page: this.page,
        size: this.size,
        startTimeString,
        endTimeString,
        branchCompanyId,
        companyId,
        searchString,
        operateType
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          data.list.forEach(item => (item.averageWeight = Number(item.averageWeight).toFixed(2)));
          this.listTable3 = data.list;
          this.total = data.total;
        }
      });
    },
    // 666666666666
   MeltRetreat(){
 
           const API = Baseurl+"inventoryController/getInventoryBatchOperateRecordList";
             const { startTimeString,
                    endTimeString,
                    branchCompanyId,
                    companyId,
                    searchString
                                } = this.formScreen
        const paramsData = {
             page: this.page,
             size: this.size,
             startTimeString,
             endTimeString,
             branchCompanyId,
             companyId,
             searchString,
            };
        ajaxPost(API,paramsData).then(res=>{
            if(res.data.code == 200){
                this.MeltRetreatData = res.data.data.list;
                 this.total = res.data.data.total;
            }else{
                this.$message.error(res.data.message)
            }
            // console.log(res)
        })
   },
    downExcel:function(){
            const { 
              startTimeString,
              endTimeString,
              branchCompanyId,
              companyId,
              searchString,
              operateType } = this.formScreen
              const paramsData = {
              startTimeString,
              endTimeString,
              branchCompanyId,
              companyId,
              searchString,
              operateType
            };
            const API = Baseurl + "inventoryController/exportInventoryOperateHistory";
            // const headers = {headers:'application/x-download'};
            const blobs = { responseType: 'blob'}
            this.$http.post(API,paramsData,blobs).then(response => {
                const blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
            //第一种
                const fileName = '出入库记录.xls';
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
                //        第二种  
                //   const url = URL.createObjectURL(blob);
                //     window.location.href = url;
                //    window.location.href = response.data;
            })
    },

    downExcel1:function(){
            const { 
              startTimeString,
              endTimeString,
              branchCompanyId,
              companyId,
              searchString,
              operateType } = this.formScreen
            const paramsData = {
              startTimeString,
              endTimeString,
              branchCompanyId,
              companyId,
              searchString,
              operateType,
              confirmStatus:0,
            };
            const API = Baseurl + "inventoryController/exportInventoryOperateHistory";
            // const headers = {headers:'application/x-download'};
            const blobs = { responseType: 'blob'}
            this.$http.post(API,paramsData,blobs).then(response => {
                const blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
            //第一种
                const fileName = '出入库.xls';
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
                //        第二种  
                //   const url = URL.createObjectURL(blob);
                //     window.location.href = url;
                //    window.location.href = response.data;
            })
    },
    // 
    ApplicationforsaveConfirm(data) {
      const API = Baseurl + "inventoryController/updateShelfsById";
      const paramsData = { ...data ,comfirmRoleId:this.UserInfo.rid};
    //   console.log(paramsData)
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          // this.infoPurchase = data;
          this.getTableData();
          this.$refs.InLibrary.close();
        //   this.getListTable();  
           
        }
      });
    },
    // 入库
    ApplicationforexportConfirm(data) {
      const API = Baseurl + "inventoryController/confirmInventoryOperate";
      const paramsData = { ...data ,comfirmRoleId:this.UserInfo.rid};
    //   console.log(JSON.parse(JSON.stringify(paramsData)));
    //   return;
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
              this.$message.success("申请入库成功")
          // this.infoPurchase = data;
          this.$refs.Applicationforexport.close();
          this.getListTable2();
        }
      });
    },
    // 销毁
    ApplicationfordestructionConfirm(data){
        // console.log(data)
      const API = Baseurl + "inventoryController/confirmInventoryOperate";
      const paramsData = { ...data ,comfirmRoleId:this.UserInfo.rid};
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          // this.infoPurchase = data;
          this.$refs.Applicationfordestruction.close();
          this.getListTable2();
        }
      });
    },
    // 出库
    ApplicationForWarehouseConfirm(data) {
      const API = Baseurl + "inventoryController/confirmInventoryOperate";
    //   console.log(data);
    //   return;
      const paramsData = { ...data ,comfirmRoleId:this.UserInfo.rid};
    //   console.log(JSON.parse(JSON.stringify(paramsData)))
    //   return;
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
            this.$message.success("申请出库成功")
          this.$refs.Applicationforwarehousing.close();
          this.getListTable2();
        }
      });
    },
    BarCode(val){
        console.log(val.shelfType);
        // return;
        const API = Baseurl + "inventoryPdfPrintController/pdfPrint";
        const paramsData = { id:val.id};
        ajaxPost(API, paramsData).then(res => {
            window.open(res.data.data, '_blank');
        });
    },
    // BarCode:function(val){
    //         const API = Baseurl + "inventoryPdfPrintController/pdfPrint";
    //         const headers = {headers:'application/x-download',id:val.id};
    //         const blobs = { responseType: 'blob'}
    //         this.$http.post(API,headers,blobs).then(response => {
    //             const blob = new Blob([response.data], {type: "application/vnd.ms-pdf"});
    //         //第一种
    //             const fileName = '条形码.pdf';
    //             const elink = document.createElement('a');
    //             elink.download = fileName;
    //             elink.style.display = 'none';
    //             elink.href = URL.createObjectURL(blob);
    //             document.body.appendChild(elink);
    //             elink.click();
    //             URL.revokeObjectURL(elink.href); // 释放URL 对象
    //             document.body.removeChild(elink);
    //             //        第二种  
    //             //   const url = URL.createObjectURL(blob);
    //             //     window.location.href = url;
    //             //    window.location.href = response.data;
    //         })
    // },
  },
};
</script>

<style lang="scss" scoped>
.storage {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;
  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}
.scope_img {
  img {
    width: 100px;
    height: 100px;
  }
}
.prduct_img {
  width: 500px;
  height: 500px;
}
</style>
